import { Button, Typography } from '@smartgift/frontend-toolkit';
import { useTranslation } from 'react-i18next';

import * as S from './style';

export function ProductOptionsByTable({ product, accordionTitleRef }) {
  const { t } = useTranslation();

  return (
    <S.AttrListWrapper>
      <Button
        variant="link"
        onClick={() => {
          accordionTitleRef.current?.click();
          accordionTitleRef.current?.focus();
          setTimeout(() => {
            accordionTitleRef.current?.scrollIntoView({ behavior: 'smooth' });
          }, 500);
        }}
      >
        {t('configureProductSelection')}
      </Button>
      <S.OptionList style={{ display: 'unset' }}>
        <Typography variant="body2Bold" style={{ marginTop: 8 }}>
          {t('availableOptions')}
        </Typography>
        {product?.skus?.map(sku => {
          const attrs = Object.keys(sku.attrs || {}).map(attr => sku.attrs[attr]);

          return (
            <S.OptionListItem key={sku.code}>
              {sku.name}
              {attrs.length > 0 && <>, {attrs.join(', ')}</>}
            </S.OptionListItem>
          );
        })}
      </S.OptionList>
    </S.AttrListWrapper>
  );
}
